import authService from '../../modules/auth/services/authService';
import { menuService } from '../../modules/menu/services/menuService';

/**
 * Verifica si las preferencias tienen todos los campos requeridos
 */
export const hasValidPreferences = (preferences) => {
    if (!preferences) {
        return false;
    }

    // Verificar que tenga todos los campos obligatorios
    return !!(
        preferences.num_people &&
        preferences.budget_level &&
        preferences.complexity &&
        preferences.goal
    );
};

/**
 * Verifica las preferencias del usuario consultando API y localStorage
 * @returns {Promise<{hasPreferences: boolean, preferences: object|null}>}
 */
export const checkUserPreferences = async () => {
    try {
        // Si está autenticado, consultar API primero
        if (authService.isAuthenticated()) {
            try {
                const response = await menuService.getPreferences();
                if (response && response.preferences) {
                    const prefs = response.preferences;

                    // Verificar si son válidas
                    if (hasValidPreferences(prefs)) {
                        // Sincronizar localStorage con preferencias de la API
                        const userDataStr = localStorage.getItem('user_data');
                        if (userDataStr) {
                            try {
                                const userData = JSON.parse(userDataStr);
                                userData.preferences = prefs;
                                localStorage.setItem('user_data', JSON.stringify(userData));
                            } catch (error) {
                            }
                        }

                        return { hasPreferences: true, preferences: prefs };
                    }
                }
            } catch (error) {
                // Continuar con verificación de localStorage como fallback
            }
        }

        // Fallback a localStorage
        const userDataStr = localStorage.getItem('user_data');
        if (userDataStr) {
            try {
                const userData = JSON.parse(userDataStr);
                if (userData.preferences && hasValidPreferences(userData.preferences)) {
                    return { hasPreferences: true, preferences: userData.preferences };
                }
            } catch (error) {
            }
        }

        return { hasPreferences: false, preferences: null };
    } catch (error) {
        return { hasPreferences: false, preferences: null };
    }
};

